import { IUser } from '../common';
import { RequestStatus } from '../admin';
import { Request } from '.';

export const panels = ({ user }: { user: IUser }) => [
  {
    value: 0,
    panel: () => <Request user={user} searchUsers={false} />,
  },
  {
    value: 1,
    panel: () => (
      <RequestStatus
        di={false}
        requestorEmail=""
        disableOperationsHelpDsk={false}
      />
    ),
  },
];
